import { Injectable } from '@angular/core';

import { ReplaySubject, Observable } from 'rxjs';

import { Platform } from 'ionic-angular';
import {
    LoggingService, FcmService, DeviceInfo
} from '@varsity/services';
import { ToastController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { Device } from '@ionic-native/device';
import { AccountService } from '../account/account.service';
import { Deeplinks } from '@ionic-native/deeplinks';

/*
  Generated class for the TicketsService provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PlatformService {
    isWebApp: boolean = false;
    // use this variable to store if the app is running on a 'tablet', 'mobile', 'desktop'
    platformDevice: string;
    platformType: string;
    public isWebAppObservable = new ReplaySubject<boolean>(1);
    public platformDeviceObservable = new ReplaySubject<string>(1);
    public platformTypeObservable = new ReplaySubject<string>(1);
    public notificationTokenObservable = new ReplaySubject<string>(1);
    public deviceInfoObservable = new ReplaySubject<DeviceInfo>(1);

    public openPageObservable = new ReplaySubject<{ page: string, params: string }>(1);
    public openPage$ = this.openPageObservable.asObservable();

    public notificationClickedObservable = new ReplaySubject<{ notificationId: number }>(1);
    public notificationClicked$ = this.notificationClickedObservable.asObservable();

    webAppFlag$ = this.isWebAppObservable.asObservable();
    platformType$ = this.platformTypeObservable.asObservable();
    platformDevice$ = this.platformDeviceObservable.asObservable();
    notificationToken$ = this.notificationTokenObservable.asObservable();
    deviceInfo$ = this.deviceInfoObservable.asObservable();


    constructor(
        private platform: Platform,
        private loggingService: LoggingService,
        private statusBar: StatusBar,
        private fcm: FcmService,
        private toastCtrl: ToastController,
        private device: Device,
        private deeplinks: Deeplinks
    ) {

    }

    setupFcm(): void {
        // push out some default values, otherwise we are stuck waiting for these in browser
        this.notificationTokenObservable.next("");
        this.deviceInfoObservable.next({});

        this.isCordova().then((result) => {
            this.deviceInfoObservable.next(this.device);
            if (result) {
                // Get a FCM token

                // TODO all this logic for getting tokens and handling push notifications should be wrapped
                // inside a grantPermission and hasPermission.
                // https://github.com/dpa99c/cordova-plugin-firebasex#grantpermission
                this.fcm.hasPermission().subscribe(
                    permissionGranted => {
                        let callback = () => {
                            this.fcm.getToken().subscribe(token => {
                                this.notificationTokenObservable.next(token);
                            });

                            this.fcm.onTokenRefresh().subscribe(
                                (newToken) => {
                                    this.notificationTokenObservable.next(newToken);
                                }
                            );

                            this.fcm.onNotificationOpen().subscribe(
                                data => {
                                    this.loggingService.debug("Notification open trigger - PLATFORM", data);
                                    if (data.tap && data.id) {
                                        this.notifyNotificationClicked(data.id);
                                    }

                                    if (data.tap && data.page) {
                                        // if they tapped on notification, no mater if in background or foreground
                                        this.notifyOpenPage(data.page, data.params);
                                    } else if ((((data || {}).aps || {}).alert || {}).body || (data || {}).body) {
                                        // data.aps.alert.body - ios, data.body - android
                                        let toast = this.toastCtrl.create({
                                            message: (((data || {}).aps || {}).alert || {}).body || (data || {}).body,
                                            duration: 7000,
                                            position: 'bottom',
                                            showCloseButton: true,
                                            dismissOnPageChange: true,
                                            cssClass: "default-toast"
                                        });

                                        toast.present();
                                    }
                                }
                            );
                        }

                        if (permissionGranted) {
                            callback();
                        } else {
                            this.fcm.grantPermission().subscribe(
                                data => {
                                    if (data) {
                                        callback();
                                    }
                                }
                            )
                        }
                    }

                );



                // TODO Add onTokenRefresh
                // https://github.com/dpa99c/cordova-plugin-firebasex#ontokenrefresh


                //this.fcm.onMessageReceivedWrapper();

                // Listen to incoming messages
                //this.fcm.listenToNotifications().pipe(
                //    tap(msg => {
                //        // show a toast
                //        const toast = this.toastCtrl.create({
                //            message: msg.body,
                //            duration: 3000
                //        });
                //        toast.present();
                //    })
                //).subscribe(
                //    msg => {
                //        // if app in background
                //        if (msg.tap) {

                //        } else {
                //        // if app in foreground
                //        // show a toast
                //            const toast = this.toastCtrl.create({
                //                message: msg.body,
                //                duration: 3000
                //            });
                //            toast.present();
                //        }
                //    });
            }
        });
    }

    setPlatformType(): void {
        this.platform.ready().then(() => {
            // https://ionicframework.com/docs/v3/api/platform/Platform/
            if (this.platform.is('android')) {
                this.platformType = 'android';
                if (this.platform.is('tablet')) {
                    this.platformDevice = 'tablet';
                } else {
                    this.platformDevice = 'mobile';
                }
                if (this.platform.is('mobileweb')) {
                    this.isWebApp = true;
                }
            } else if (this.platform.is('ios')) {
                this.platformType = 'ios';
                if (this.platform.is('tablet')) {
                    this.platformDevice = 'tablet';
                } else {
                    this.platformDevice = 'mobile';
                }
                if (this.platform.is('mobileweb')) {
                    this.isWebApp = true;
                }
            } else if (this.platform.is('windows')) {
                this.platformType = 'windows';
                if (this.platform.is('tablet')) {
                    this.platformDevice = 'tablet';
                } else {
                    this.platformDevice = 'mobile';
                }
                if (this.platform.is('mobileweb')) {
                    this.isWebApp = true;
                }
            } else if (this.platform.is('mobile')) {
                this.platformType = 'mobile';
                if (this.platform.is('tablet')) {
                    this.platformDevice = 'tablet';
                } else {
                    this.platformDevice = 'mobile';
                }
                if (this.platform.is('mobileweb')) {
                    this.isWebApp = true;
                }
            } else if (this.platform.is('mobileweb')) {
                this.platformType = 'mobileweb';
                if (this.platform.is('tablet')) {
                    this.platformDevice = 'tablet';
                } else {
                    this.platformDevice = 'mobile';
                }
                this.isWebApp = true;
            } else if (this.platform.is('core')) {
                this.platformType = 'web';
                this.platformDevice = 'desktop';
                this.isWebApp = true;
            } else {
                this.platformType = 'unknown';
                this.platformDevice = 'unknown';
            }

            //this.loggingService.log("Platform Type: ", this.platformType);
            //this.loggingService.log("Platform Device: ", this.platformDevice);
            this.isWebAppObservable.next(this.isWebApp);
            this.platformDeviceObservable.next(this.platformDevice);
            this.platformTypeObservable.next(this.platformType);

            this.isCordova().then((v) => {
                if (v) {
                    this.statusBar.overlaysWebView(false);
                }
            }, (error) => {

            });
        });
    }

    notifyOpenPage(page: string, params: string): void {
        this.openPageObservable.next({ page, params });
    }

    notifyNotificationClicked(notificationId: number): void {
        this.notificationClickedObservable.next({ notificationId });
    }

    registerBackButton(): Observable<any> {
        return new Observable<any>(observer => {
            this.platform.ready().then(() => {
                this.platform.registerBackButtonAction(() => {
                    this.loggingService.info('device back button clicked');
                    observer.next();
                });
            });
        });
    }

    exitApp() {
        this.platform.ready().then(() => {
            this.platform.exitApp();
        });
    }

    isCordova(): Promise<any> {
        var promise = new Promise<any>((resolve, reject) => {
            this.platform.ready().then(() => {
                resolve(this.platform.is('cordova'));
            }).catch((reason) => {
                reject(reason);
            });
        });

        return promise;
    }

    handleDeepLinks() {
        // https://github.com/ionic-team/ionic-plugin-deeplinks
        this.isCordova().then((result) => {
            this.deeplinks.route({
                '/': '',
                '/VarsityTix-Dev/': '',
                '/VarsityTix-QA/': '',
                '/VarsityTix-Dev-RR/': '',
                '/stage/': '',
            }).subscribe((match) => {
                // match.$route - the route we matched, which is the matched entry from the arguments to route()
                // match.$args - the args passed in the link
                // match.$link - the full link data
                this.loggingService.log('Successfully matched depplink route', match);

                if (!match.$link.fragment) {
                    this.notifyOpenPage('home', null);
                } else {
                    if (match.$link.fragment.indexOf('/event-tickets/') > -1) {
                        let fragments = (match.$link.fragment as string).split('/');
                        fragments = fragments.filter(p => p.length > 0);
                        this.loggingService.log('Successfully matched depplink route', fragments);
                        if (fragments.length === 4) {
                            this.notifyOpenPage('event-tickets', JSON.stringify({
                                sponsorID: fragments[1],
                                eventID: fragments[2],
                                randomID: fragments[3]
                            }));

                            return;
                        }

                        if (fragments.length === 5) {
                            this.notifyOpenPage('direct-link-event-tickets', JSON.stringify({
                                sponsorID: fragments[1],
                                eventID: fragments[2],
                                promoCode: fragments[3],
                                randomID: fragments[4]
                            }));

                            return;
                        }

                        if (fragments.length === 7) {
                            this.notifyOpenPage('direct-link-login-event-tickets', JSON.stringify({
                                sponsorID: fragments[1],
                                eventID: fragments[2],
                                promoCode: fragments[3],
                                userID: fragments[4],
                                password: fragments[5],
                                randomID: fragments[6]
                            }));

                            return;
                        }
                    }

                    //direct-account-tickets/:validationToken/:confirmationID/:eventID/:sponsorID/:randomID
                    if (match.$link.fragment.indexOf('/direct-account-tickets/') > -1) {
                        let fragments = (match.$link.fragment as string).split('/');
                        fragments = fragments.filter(p => p.length > 0);
                        this.loggingService.log('Successfully matched depplink route', fragments);
                        if (fragments.length === 6) {
                            this.notifyOpenPage('direct-account-tickets', JSON.stringify({
                                validationToken: fragments[1],
                                confirmationID: fragments[2],
                                eventID: fragments[3],
                                sponsorID: fragments[4],
                                randomID: fragments[5]
                            }));

                            return;
                        }
                    }

                    if (match.$link.fragment.indexOf('/account-tickets/') > -1) {
                        let fragments = (match.$link.fragment as string).split('/');
                        fragments = fragments.filter(p => p.length > 0);
                        this.loggingService.log('Successfully matched depplink route', fragments);
                        if (fragments.length === 4) {
                            this.notifyOpenPage('account-tickets', JSON.stringify({
                                eventID: fragments[1],
                                sponsorID: fragments[2],
                                randomID: fragments[3]
                            }));

                            return;
                        }
                    }

                    if (match.$link.fragment.indexOf('/account') > -1) {
                        let fragments = (match.$link.fragment as string).split('/');
                        fragments = fragments.filter(p => p.length > 0);
                        this.loggingService.log('Successfully matched depplink route', fragments);
                        if (fragments.length === 1) {
                            this.notifyOpenPage('account', JSON.stringify({
                            }));

                            return;
                        }
                    }

                    if (match.$link.fragment.indexOf('/events/') > -1) {
                        let fragments = (match.$link.fragment as string).split('/');
                        fragments = fragments.filter(p => p.length > 0);
                        this.loggingService.log('Successfully matched depplink route', fragments);
                        if (fragments.length === 2) {
                            this.notifyOpenPage('events', JSON.stringify({
                                sponsorID: fragments[1]
                            }));

                            return;
                        }
                        //New Code for Promos
                        if (fragments.length === 4) {
                            this.notifyOpenPage('direct-link-events', JSON.stringify({
                                eventID: fragments[1],
                                promoCode: fragments[2],
                                randomID: fragments[3]
                            }));

                            return;
                        }
                    }

                    if (match.$link.fragment.indexOf('/purchase-completed/') > -1) {
                        let fragments = (match.$link.fragment as string).split('/');
                        fragments = fragments.filter(p => p.length > 0);
                        if (fragments.length === 2) {
                            this.notifyOpenPage('purchase-completed', JSON.stringify({
                                sessionID: fragments[1]
                            }));

                            return;
                        }
                    }

                    if (match.$link.fragment.indexOf('/cart/') > -1) {
                        let fragments = (match.$link.fragment as string).split('/');
                        fragments = fragments.filter(p => p.length > 0);
                        if (fragments.length === 2) {
                            this.notifyOpenPage('cart-stripe-return', JSON.stringify({
                                sessionID: fragments[1]
                            }));

                            return;
                        }
                    }
                    // TODO add matching for purchase-completed and cart
                    // otherwise the native app will not know how to redirect the user
                }
            },
                (nomatch) => {
                    // nomatch.$link - the full link data
                    this.loggingService.error('Got a deeplink that didn\'t match', nomatch);
                });

            //if (result) {
            //    const universalLinks = (window as any).universalLinks;
            //    if (universalLinks) {
            //        universalLinks.subscribe('vtix_openlink', (eventData) => {
            //            /*
            //             * {
            //                  "url": "http://myhost.com/news/ul-plugin-released.html?foo=bar#cordova-news",
            //                  "scheme": "http",
            //                  "host": "myhost.com",
            //                  "path": "/news/ul-plugin-released.html",
            //                  "params": {
            //                    "foo": "bar"
            //                  },
            //                  "hash": "cordova-news"
            //                }
            //            */

            //            const url = eventData.url;
            //            // parse URL and go to page
            //            this.notifyOpenPage("", "");
            //        });
            //    }
            //}
        });
    }

    getSite() {
        if (window.location.href.toLowerCase().indexOf('varsity') > -1) {
            return "TR Varsity";
        } if (window.location.href.toLowerCase().indexOf('sideline') > -1) {
            return "Sideline Tix";
        } else { //default to this for development
            return "TR Varsity";
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/platform/platform.service.ts